// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1FTtH","title":"ClientReferral_title__1VBAl","itemText":"ClientReferral_itemText__1ctA2"};